import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

export const Background = styled.div<{ backgroundImage: string }>`
  position: relative;
  width: 100%;
  height: 305px;
  display: flex;
  background: linear-gradient(to right, #0402fd 0%, #f4111b 100%);
  margin-bottom: 1rem;

  @media ${breakpoints.tablet} {
    margin-bottom: 3rem;
    width: 100vw;
    aspect-ratio: 16 / 6;
    ${({ backgroundImage }) => `background-image: url(${backgroundImage});`}
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    height: auto;

    @media (max-width: 768px) {
      aspect-ratio: 16 / 10;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  background: linear-gradient(to right, rgba(4, 2, 253, 0.8) 0%, rgba(244, 17, 27, 0.8) 100%);

  @media ${breakpoints.tablet} {
    background: linear-gradient(
      to right,
      rgba(4, 2, 253, 0.8) 0%,
      rgba(244, 17, 27, 0.8) 50%,
      rgba(244, 17, 27, 0.5) 100%
    );
  }
`;

export const ContentSection = styled.div`
  position: relative;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 455px;

  @media ${breakpoints.tablet} {
    margin: 0;
    margin-left: 6.5%;
  }

  & h1 {
    font-family: Geomanist;
    font-weight: 500;
    font-size: 26px;
    line-height: 26px;
    max-width: 230px;
    padding-left: 18px;

    @media ${breakpoints.tablet} {
      font-size: 39px;
      line-height: 43px;
      padding-left: 0;
    }

    @media ${breakpoints.desktopLarge} {
      font-size: 55px;
      line-height: 65px;
    }
  }

  & p {
    color: white;
    font-family: Geomanist;
    font-weight: 100;
    font-size: 14px;
    line-height: 18px;
    max-width: 230px;
    margin-top: 10px;
    padding-left: 10px;

    @media ${breakpoints.tablet} {
      max-width: 455px;
      padding-left: 0;
    }

    @media ${breakpoints.desktopLarge} {
      font-size: 20px;
      line-height: 28px;
    }
  }
`;

export const MobileImage = styled.div`
  position: absolute;
  right: 0;
  top: 7%;
  z-index: 10;
  display: flex;
  align-items: flex-end;

  @media ${breakpoints.tablet} {
    display: none;
  }

  img {
    width: auto;
    max-height: 170px;
  }
`;

export const StyledPostcodeSearch = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-start;
  max-width: 455px;

  @media ${breakpoints.desktopLarge} {
    margin-top: 2rem;
  }

  form {
    width: 100%;
  }
`;

export const StyledActionsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  max-width: 455px;
  margin-top: 1.25rem;
  gap: 1.5rem;
`;
